import React, { useEffect, useState } from 'react';
import { collection, doc, getDocs, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import './AdminTournamentArchive.css';

const AdminTournamentArchive = () => {
  const [tournaments, setTournaments] = useState([]);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [participants, setParticipants] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      const snap = await getDocs(collection(db, 'tournament-v2', 'archived', 'list'));
      const docs = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setTournaments(docs);
    };

    fetchHistory();
  }, []);

  const loadParticipants = async (tournamentId) => {
    const snap = await getDocs(collection(db, 'tournament-v2', 'archived', 'list', tournamentId, 'participants'));
    const docs = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    setParticipants(docs);
  };

  const handleTournamentClick = async (tournament) => {
    setSelectedTournament(tournament);
    await loadParticipants(tournament.id);
  };

  const handleBackToList = () => {
    setSelectedTournament(null);
    setParticipants([]);
  };

  return (
    <div className="admin-tournament-archive-container">
      <h2>🗂 Tournament Archive</h2>

      {!selectedTournament ? (
        <>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Date</th>
                <th>Format</th>
                <th>Platform</th>
              </tr>
            </thead>
            <tbody>
              {tournaments.map((t) => (
                <tr key={t.id} onClick={() => handleTournamentClick(t)} style={{ cursor: 'pointer' }}>
                  <td>{t.title}</td>
                  <td>{t.date}</td>
                  <td>{t.format}</td>
                  <td>{t.platform}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => navigate('/admin')}>Back to Dashboard</button>
        </>
      ) : (
        <>
          <h3>{selectedTournament.title} – Participants</h3>
          <p><strong>Date:</strong> {selectedTournament.date}</p>
          <p><strong>Platform:</strong> {selectedTournament.platform}</p>
          <p><strong>Format:</strong> {selectedTournament.format}</p>

          {participants.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Pseudo</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                {participants.map(p => (
                  <tr key={p.id}>
                    <td>{p.pseudo}</td>
                    <td>{p.result}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No participants found.</p>
          )}

          <div className="archive-buttons">
            <button onClick={handleBackToList}>← Back to Archive</button>
            <button onClick={() => navigate('/admin')}>Back to Dashboard</button>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminTournamentArchive;
